/* eslint-disable */

import React from "react";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import Image from "../image/Image.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";

const RaindropInputFile = ({
  setImageUrl = (url) => {},
  imageUrl = "#",
  onChange = (e) => {},
  label = "my label",
}) => {
  const [internalImageUrl, setInternalImageUrl] = React.useState(imageUrl);

  const fileInput = React.useRef(null);

  const handleImageUploadBackground = (e) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    setInternalImageUrl(url);

    if (setImageUrl) {
      setImageUrl(URL.createObjectURL(file));
    }

    onChange(e);
  };

  const onClick = () => {
    if (fileInput.current) {
      fileInput.current.click();
    }
  };

  const imageNotSet =
    internalImageUrl === undefined || internalImageUrl === "#";

  return (
    <RaindropClickable onClick={onClick}>
      <RaindropCard>
        <div className="flex flex-col items-center justify-center w-[200px] h-[200px] rounded-lg  ">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUploadBackground}
            className="hidden"
            ref={fileInput}
          />

          <div className="flex w-full h-full justify-center items-center ">
            {imageNotSet && (
              <div className="flex flex-col items-center gap-2">
                <i className="fas fa-upload text-lg"></i>
                <div className="text-center text-sm">
                  Click to upload an image
                </div>
              </div>
            )}

            {!imageNotSet && (
              <div className="flex flex-col w-full h-full relative items-center justify-center group">
                <img
                  src={internalImageUrl}
                  alt=""
                  className="w-full h-full object-cover border border-color-dark-border-primary rounded-lg"
                />
              </div>
            )}
          </div>
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

export default RaindropInputFile;
